import { render } from "./AuditViewer.vue?vue&type=template&id=6ad74c13&ts=true"
import script from "./AuditViewer.vue?vue&type=script&lang=ts"
export * from "./AuditViewer.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__